/** Per-commentator neon hues */
export const COMMENTATOR_HUE: Record<string, number> = {
  grak_ironjaw: 25, // hot orange-red
  skrix_dataclack: 280, // electric violet
  vaeltharion_the_unimpressed: 200, // icy cyan
  midge_tumblebottom: 330, // hot pink
  mortifax_greel: 0, // blood red
}
export const DEFAULT_HUE = 55

export function commentatorNeon(key: string) {
  const h = COMMENTATOR_HUE[key] ?? DEFAULT_HUE
  return {
    neon: `oklch(0.80 0.30 ${h})`,
    glow: `oklch(0.80 0.30 ${h} / 0.7)`,
    soft: `oklch(0.80 0.30 ${h} / 0.15)`,
  }
}
